import { config } from '@cfg';
import { CreateLoftyLeadDto } from '@engelvoelkersamericas/api';
import { apiClient } from 'api-client';

const handleRecaptchaAndLofty = async (
  chimeObj: CreateLoftyLeadDto,
  sendForm: () => void,
  setRecaptchaError: React.Dispatch<React.SetStateAction<string | null>>,
  setIsSuccess: (val: boolean) => void,
  setFormSuccess?: (val: boolean) => void,
) => {
  window.grecaptcha.ready(function () {
    window.grecaptcha
      .execute(config.recaptcha.key, { action: 'submit' })
      .then(async function (token) {
        // Add your logic to submit to your backend server here.
        const response = await apiClient.verifyRecaptcha({
          recaptchaBody: { token },
        });

        if (response.data.score && response.data.score >= 0.5) {
          setRecaptchaError('');

          const results = await apiClient.createLoftyLeads({
            createLoftyLeadDto: chimeObj,
          });

          sendForm();
          setIsSuccess(results ? true : false);
          setFormSuccess && setFormSuccess(results ? true : false);

          //For better debugging
          console.log('Data sent: ', chimeObj);
          console.log('Results: ', results);
        } else {
          setRecaptchaError('reCAPTCHA verification failed. Please try again.');
          throw new Error('reCAPTCHA verification failed');
        }
      });
  });
};

export default handleRecaptchaAndLofty;
